import Header from "@/components/hotel/Header";
import SubpageHero from "@/components/hotel/SubpageHero";
import BadRagaz from "@/components/hotel/BadRagaz";
import Footer from "@/components/hotel/Footer";
import SEO from "@/components/SEO";
import { useLanguage } from "@/i18n/LanguageContext";

const BadRagazPage = () => {
  const { t } = useLanguage();
  return (
    <main id="main-content" className="min-h-screen bg-background">
      <SEO
        title="Bad Ragaz"
        description="Entdecken Sie Bad Ragaz – Thermalquellen, Wanderwege, Skigebiete und Sehenswürdigkeiten rund um das ESOS Hotel Quelle."
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Bad Ragaz", path: "/bad-ragaz" },
        ]}
      />
      <Header />
      <SubpageHero title={t.subpageHeroes.badRagaz.title} subtitle={t.subpageHeroes.badRagaz.subtitle} />
      <BadRagaz />
      <Footer />
    </main>
  );
};

export default BadRagazPage;
